import { createFileRoute } from "@tanstack/react-router";

import {
  getProductPaymentsPageQuery,
  productPaymentsSearchSchema,
} from "src/helpers/productPaymentsPageQuery";
import { CoachAthletePaymentsPage } from "src/pages/CoachAthletePaymentsPage";
import { athleteProductPaymentsQueryOptions } from "src/queries/productSubscriptions";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/payments",
)({
  component: CoachAthletePaymentsPage,
  validateSearch: productPaymentsSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return getProductPaymentsPageQuery(search);
  },
  async loader({ context, params, deps }) {
    return context.queryClient.query({
      ...athleteProductPaymentsQueryOptions(params.athleteId, deps),
      staleTime: "static",
    });
  },
});
